import React from "react";
import "./RecommendedProducts.scss";

import first from "./assets/product-1.png";
import second from "./assets/product-2.png";
import third from "./assets/product-3.png";
import Tilt from "react-parallax-tilt";

const RecommendedProducts = () => {
  return (
    <section className="recommended-products scheme">
      <div className="recommended-products__title">
        <h2 className="section__title">Рекомендуемые товары</h2>
      </div>

      <div className="recommended-products__cards">
        <Tilt
          className="recommended-products__card"
          scale={1.1}
          transitionSpeed={2500}
        >
          <div className="recommended-products__card-image">
            <img src={first} alt="Зубная паста Splat Бабл Гам" />
          </div>

          <div className="recommended-products__card-title">
            <h3>Зубная паста Splat Бабл Гам</h3>
          </div>
        </Tilt>

        <Tilt
          className="recommended-products__card"
          scale={1.1}
          transitionSpeed={2500}
        >
          <div className="recommended-products__card-image">
            <img src={second} alt="Зубная щетка Splat Junior Ultra 4200" />
          </div>

          <div className="recommended-products__card-title">
            <h3>Зубная щетка Splat Junior Ultra 4200</h3>
          </div>
        </Tilt>

        <Tilt
          className="recommended-products__card"
          scale={1.1}
          transitionSpeed={2500} 
        >
          <div className="recommended-products__card-image">
            <img src={third} alt="Зубная паста Splat Ягодный коктейль" />
          </div>

          <div className="recommended-products__card-title">
            <h3>Зубная паста Splat Ягодный коктейль</h3>
          </div>
        </Tilt>
      </div>
    </section>
  );
};

export default RecommendedProducts;
